import React, { useState } from "react";
import { createLinkedTodo, postComptaStageForm, finalizeComptaStage } from "./comptaStageHelpers";
import NotifyPicker from "./NotifyPicker";
import { CommentField, CheckField, ToggleGroup, ReadField, SubmitBar } from "./FormFields";
import { cardCls, subCardCls, cycleTitleCls } from "./formStyles";

const INITIAL_FORM = {
  cycleTraite: "",
  commentaire1: "",
  commentaire2: "",
  rapprochementBanque: "",
  nouvelEmprunt: "",
  variationSignificative: "",
  evolutionAnormale: "",
  fraisRejet: "",
  commentaire3: "",
  fdivers: "",
  lettrage: "",
  verificationElimination: "",
  dettes: "",
  commentaire4: "",
  sondage: "",
  evolutionSignificative2: "",
  commentaire5: "",
  cdivers: "",
  lettrageComtpes: "",
  verificationElimination2: "",
  creanceClient: "",
  evolutionChiffre: "",
  impactCA: "",
  commentaire6: "",
  commentaire7: "",
  immobilisation: "",
  commentaire8: "",
  transfertOD: "",
  retardPaiement: "",
  presenceDettes: "",
  commentaire9: "",
  tansfertODetTVA: "",
  retardPaiementEcheance: "",
  dettesFiscales: "",
  regimeImposition: "",
  declarationAjour: "",
  commentaire10: "",
  commentaire11: "",
  commentaire12: "",
  userIds: [],
};

const CYCLE_LEFT = [
  { key: "B", label: "B - Trésorerie / finances" },
  { key: "D", label: "D - Chardes externes" },
  { key: "F", label: "F - Stockes et travaux en cours" },
  { key: "H", label: "H - Personnel" },
  { key: "J", label: "J - Capitaux propres" },
];

const CYCLE_RIGHT = [
  { key: "C", label: "C - Achats / fournisseurs" },
  { key: "E", label: "E - Ventes / clients" },
  { key: "G", label: "G - Immobilisation" },
  { key: "I", label: "I - Etat" },
  { key: "K", label: "K - Autres comptes" },
];

// Étape 4/5 — tache.type "Traitement niv.1" (nommage historique un peu
// trompeur : ce type de tâche appelle l'endpoint /traitement2 et lit
// tache.traitement2Form, anciennement handleSubmitTR2 — conservé tel quel).
// C'est le formulaire "Analyse par cycle" (~39 champs formData A à K).
function Traitement2Stage({
  tache,
  showFormInstead,
  selectedClient,
  selectedYear,
  selectedMonth,
  refetch,
  setShowOverlay,
  allUsers,
  utilisateur,
}) {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleCycleToggle = (item, checked) => {
    let selected = formData.cycleTraite
      ? formData.cycleTraite.split(",").map((v) => v.trim())
      : [];
    if (checked) {
      if (!selected.includes(item.label)) selected.push(item.label);
    } else {
      selected = selected.filter((v) => v !== item.label);
    }
    setFormData({ ...formData, cycleTraite: selected.join(", ") });
  };

  const isCycleChecked = (item) =>
    formData.cycleTraite
      ? formData.cycleTraite.split(",").map((v) => v.trim()).includes(item.label)
      : false;

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Cf. TriStage / Traitement1Stage : commentaire du todo systématiquement
      // vide dans le parcours normal d'origine — reproduit fidèlement.
      const todoId = await createLinkedTodo({
        title: "Traitement comptable niv.1 - Suivi Compta",
        selectedClient,
        userIds: [selectedClient.id_collaborateur],
        commentaire: "",
      });

      const payloadTR2 = {
        cycleTraite: formData.cycleTraite,
        commentaire1: formData.commentaire1,
        commentaire2: formData.commentaire2,
        rapprochementBanque: formData.rapprochementBanque,
        nouvelEmprunt: formData.nouvelEmprunt,
        variationSignificative: formData.variationSignificative,
        evolutionAnormale: formData.evolutionAnormale,
        fraisRejet: formData.fraisRejet,
        commentaire3: formData.commentaire3,
        fdivers: formData.fdivers,
        lettrage: formData.lettrage,
        verificationElimination: formData.verificationElimination,
        dettes: formData.dettes,
        commentaire4: formData.commentaire4,
        sondage: formData.sondage,
        evolutionSignificative2: formData.evolutionSignificative2,
        commentaire5: formData.commentaire5,
        cdivers: formData.cdivers,
        lettrageComtpes: formData.lettrageComtpes,
        verificationElimination2: formData.verificationElimination2,
        creanceClient: formData.creanceClient,
        evolutionChiffre: formData.evolutionChiffre,
        impactCA: formData.impactCA,
        commentaire6: formData.commentaire6,
        commentaire7: formData.commentaire7,
        immobilisation: formData.immobilisation,
        commentaire8: formData.commentaire8,
        transfertOD: formData.transfertOD,
        retardPaiement: formData.retardPaiement,
        presenceDettes: formData.presenceDettes,
        commentaire9: formData.commentaire9,
        tansfertODetTVA: formData.tansfertODetTVA,
        retardPaiementEcheance: formData.retardPaiementEcheance,
        dettesFiscales: formData.dettesFiscales,
        regimeImposition: formData.regimeImposition,
        declarationAjour: formData.declarationAjour,
        commentaire10: formData.commentaire10,
        commentaire11: formData.commentaire11,
        commentaire12: formData.commentaire12,
        assignedTo: formData.userIds.join(","),
        TodoCreate: todoId,
      };

      const tacheId = await postComptaStageForm({
        clientId: selectedClient.id,
        year: selectedYear,
        month: selectedMonth,
        stage: "traitement2",
        payload: payloadTR2,
      });

      const emailTR2Payload = {
        NomComplet: `${utilisateur.lastName} ${utilisateur.name}`,
        cycleTraite: formData.cycleTraite,
        commentaire1: formData.commentaire1,
        commentaire2: formData.commentaire2,
        rapprochementBanque: formData.rapprochementBanque,
        nouvelEmprunt: formData.nouvelEmprunt,
        variationSignificative: formData.variationSignificative,
        evolutionAnormale: formData.evolutionAnormale,
        fraisRejet: formData.fraisRejet,
        commentaire3: formData.commentaire3,
        fdivers: formData.fdivers,
        lettrage: formData.lettrage,
        verificationElimination: formData.verificationElimination,
        dettes: formData.dettes,
        commentaire4: formData.commentaire4,
        sondage: formData.sondage,
        evolutionSignificative2: formData.evolutionSignificative2,
        commentaire5: formData.commentaire5,
        cdivers: formData.cdivers,
        lettrageComtpes: formData.lettrageComtpes,
        verificationElimination2: formData.verificationElimination2,
        creanceClient: formData.creanceClient,
        evolutionChiffre: formData.evolutionChiffre,
        impactCA: formData.impactCA,
        commentaire6: formData.commentaire6,
        commentaire7: formData.commentaire7,
        immobilisation: formData.immobilisation,
        commentaire8: formData.commentaire8,
        transfertOD: formData.transfertOD,
        retardPaiement: formData.retardPaiement,
        presenceDettes: formData.presenceDettes,
        commentaire9: formData.commentaire9,
        tansfertODetTVA: formData.tansfertODetTVA,
        retardPaiementEcheance: formData.retardPaiementEcheance,
        dettesFiscales: formData.dettesFiscales,
        regimeImposition: formData.regimeImposition,
        declarationAjour: formData.declarationAjour,
        commentaire10: formData.commentaire10,
        commentaire11: formData.commentaire11,
        commentaire12: formData.commentaire12,
        userEmails: formData.userIds,
      };
      const clientIdTR2 = selectedClient.id;

      setLoading(false);
      setShowOverlay(false);
      setSuccess(true);
      setFormData(INITIAL_FORM);

      finalizeComptaStage({
        clientId: clientIdTR2,
        tacheId,
        emailEndpoint: "https://backend-myalfa.vercel.app/api/email-tri2",
        emailPayload: emailTR2Payload,
        prevTodoEndpoint: `https://backend-myalfa.vercel.app/api/compta/${clientIdTR2}/${selectedYear}/${selectedMonth}/traitement1/todo`,
        refetch,
      });
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showFormInstead && (
        <form
          className={cardCls}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(tache.id);
          }}
        >
          <p className="text-sm font-bold text-[#5C1A30]">4 / Traitement comptable niv.1</p>

          <div>
            <p className="text-xs font-semibold text-gray-700 mb-2">Cycle traité :</p>
            <div className="grid grid-cols-2 gap-x-8 gap-y-2">
              <div className="flex flex-col gap-2">
                {CYCLE_LEFT.map((item) => (
                  <CheckField
                    key={item.key}
                    label={item.label}
                    checked={isCycleChecked(item)}
                    onChange={(e) => handleCycleToggle(item, e.target.checked)}
                  />
                ))}
              </div>
              <div className="flex flex-col gap-2">
                {CYCLE_RIGHT.map((item) => (
                  <CheckField
                    key={item.key}
                    label={item.label}
                    checked={isCycleChecked(item)}
                    onChange={(e) => handleCycleToggle(item, e.target.checked)}
                  />
                ))}
              </div>
            </div>
          </div>

          <CommentField
            value={formData.commentaire1}
            onChange={(e) => setFormData({ ...formData, commentaire1: e.target.value })}
          />

          <p className="text-base font-bold text-[#5C1A30] text-center pt-2">Analyse par cycle</p>

          {/* A - Régularité formelle */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>A - Régularité formelle</p>
            <CommentField
              value={formData.commentaire2}
              onChange={(e) => setFormData({ ...formData, commentaire2: e.target.value })}
            />
          </div>

          {/* B - Trésorerie / finances */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>B - Trésorerie / finances</p>
            <CheckField
              label="Rapprochement bancaire effectué"
              checked={formData.rapprochementBanque === "Oui"}
              onChange={(e) =>
                setFormData({ ...formData, rapprochementBanque: e.target.checked ? "Oui" : "" })
              }
            />
            <ToggleGroup
              label="Souscription d'un nouvel emprunt ?"
              value={formData.nouvelEmprunt}
              onChange={(v) => setFormData({ ...formData, nouvelEmprunt: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="Variation significative de la trésorerie ?"
              value={formData.variationSignificative}
              onChange={(v) => setFormData({ ...formData, variationSignificative: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="Evolution anormale du c/ct ?"
              value={formData.evolutionAnormale}
              onChange={(v) => setFormData({ ...formData, evolutionAnormale: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="Frais de rejet ou agios dans les 6. ?"
              value={formData.fraisRejet}
              onChange={(v) => setFormData({ ...formData, fraisRejet: v })}
              options={["Oui", "Non"]}
            />
            <CommentField
              value={formData.commentaire3}
              onChange={(e) => setFormData({ ...formData, commentaire3: e.target.value })}
            />
          </div>

          {/* C - Achats / fournisseurs */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>C - Achats / fournisseurs</p>
            <CheckField
              label="Traitement du compte FDIVERS"
              checked={formData.fdivers === "Oui"}
              onChange={(e) => setFormData({ ...formData, fdivers: e.target.checked ? "Oui" : "" })}
            />
            <CheckField
              label="Lettrage des comptes fournisseurs"
              checked={formData.lettrage === "Oui"}
              onChange={(e) => setFormData({ ...formData, lettrage: e.target.checked ? "Oui" : "" })}
            />
            <CheckField
              label="Vérification et élimination des doublons"
              checked={formData.verificationElimination === "Oui"}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  verificationElimination: e.target.checked ? "Oui" : "",
                })
              }
            />
            <ToggleGroup
              label="Présence de dettes fournisseurs de plus de 6 mois ?"
              value={formData.dettes}
              onChange={(v) => setFormData({ ...formData, dettes: v })}
              options={["Oui", "Non"]}
            />
            <CommentField
              value={formData.commentaire4}
              onChange={(e) => setFormData({ ...formData, commentaire4: e.target.value })}
            />
          </div>

          {/* D - Charges externes */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>D - Charges externes</p>
            <CheckField
              label="Sondage du compte 60630"
              checked={formData.sondage === "Oui"}
              onChange={(e) => setFormData({ ...formData, sondage: e.target.checked ? "Oui" : "" })}
            />
            <ToggleGroup
              label="Evolution significative d'un compte de charges externes ?"
              value={formData.evolutionSignificative2}
              onChange={(v) => setFormData({ ...formData, evolutionSignificative2: v })}
              options={["Oui", "Non"]}
            />
            <CommentField
              value={formData.commentaire5}
              onChange={(e) => setFormData({ ...formData, commentaire5: e.target.value })}
            />
          </div>

          {/* E - Ventes / clients */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>E - Ventes / clients</p>
            <CheckField
              label="Traitement du compte CDIVERS"
              checked={formData.cdivers === "Oui"}
              onChange={(e) => setFormData({ ...formData, cdivers: e.target.checked ? "Oui" : "" })}
            />
            <CheckField
              label="Lettrage des comptes clients"
              checked={formData.lettrageComtpes === "Oui"}
              onChange={(e) =>
                setFormData({ ...formData, lettrageComtpes: e.target.checked ? "Oui" : "" })
              }
            />
            <CheckField
              label="Vérification et élimination des doublons"
              checked={formData.verificationElimination2 === "Oui"}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  verificationElimination2: e.target.checked ? "Oui" : "",
                })
              }
            />
            <ToggleGroup
              label="Présence de créances clients de plus de 6 mois ?"
              value={formData.creanceClient}
              onChange={(v) => setFormData({ ...formData, creanceClient: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="Evolution significative du chiffre d'affaires ?"
              value={formData.evolutionChiffre}
              onChange={(v) => setFormData({ ...formData, evolutionChiffre: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="Impact de l'évolution du CA sur le régime de TVA ?"
              value={formData.impactCA}
              onChange={(v) => setFormData({ ...formData, impactCA: v })}
              options={["Oui", "Non"]}
            />
            <CommentField
              value={formData.commentaire6}
              onChange={(e) => setFormData({ ...formData, commentaire6: e.target.value })}
            />
          </div>

          {/* F - Stocks et travaux-en-cours */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>F - Stocks et travaux-en-cours</p>
            <CommentField
              value={formData.commentaire7}
              onChange={(e) => setFormData({ ...formData, commentaire7: e.target.value })}
            />
          </div>

          {/* G - Immobilisations */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>G - Immobilisations</p>
            <CheckField
              label="Création d'immobilisations"
              checked={formData.immobilisation === "Oui"}
              onChange={(e) =>
                setFormData({ ...formData, immobilisation: e.target.checked ? "Oui" : "" })
              }
            />
            <CommentField
              value={formData.commentaire8}
              onChange={(e) => setFormData({ ...formData, commentaire8: e.target.value })}
            />
          </div>

          {/* H - Personnel */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>H - Personnel</p>
            <CheckField
              label="Transfert des OD de paie"
              checked={formData.transfertOD === "Oui"}
              onChange={(e) =>
                setFormData({ ...formData, transfertOD: e.target.checked ? "Oui" : "" })
              }
            />
            <ToggleGroup
              label="Retard de paiement des échéances antérieures ?"
              value={formData.retardPaiement}
              onChange={(v) => setFormData({ ...formData, retardPaiement: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="Présence de dettes sociales élevées ?"
              value={formData.presenceDettes}
              onChange={(v) => setFormData({ ...formData, presenceDettes: v })}
              options={["Oui", "Non"]}
            />
            <CommentField
              value={formData.commentaire9}
              onChange={(e) => setFormData({ ...formData, commentaire9: e.target.value })}
            />
          </div>

          {/* I - Etat */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>I - Etat</p>
            <CheckField
              label="Transfert des OD de TVA"
              checked={formData.tansfertODetTVA === "Oui"}
              onChange={(e) =>
                setFormData({ ...formData, tansfertODetTVA: e.target.checked ? "Oui" : "" })
              }
            />
            <ToggleGroup
              label="Retard de paiement des échéances antérieures ?"
              value={formData.retardPaiementEcheance}
              onChange={(v) => setFormData({ ...formData, retardPaiementEcheance: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="Présence de dettes fiscales élevées ?"
              value={formData.dettesFiscales}
              onChange={(v) => setFormData({ ...formData, dettesFiscales: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="Régime d'imposition à modifier ?"
              value={formData.regimeImposition}
              onChange={(v) => setFormData({ ...formData, regimeImposition: v })}
              options={["Oui", "Non"]}
            />
            <ToggleGroup
              label="L'ensemble des déclarations sont à jour ?"
              value={formData.declarationAjour}
              onChange={(v) => setFormData({ ...formData, declarationAjour: v })}
              options={["Oui", "Non"]}
            />
            <CommentField
              value={formData.commentaire10}
              onChange={(e) => setFormData({ ...formData, commentaire10: e.target.value })}
            />
          </div>

          {/* J - Capitaux propres */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>J - Capitaux propres</p>
            <CommentField
              value={formData.commentaire11}
              onChange={(e) => setFormData({ ...formData, commentaire11: e.target.value })}
            />
          </div>

          {/* K - Autres comptes */}
          <div className={subCardCls}>
            <p className={cycleTitleCls}>K - Autres comptes</p>
            <CommentField
              value={formData.commentaire12}
              onChange={(e) => setFormData({ ...formData, commentaire12: e.target.value })}
            />
          </div>

          <NotifyPicker allUsers={allUsers} formData={formData} setFormData={setFormData} />

          <SubmitBar loading={loading} error={error} success={success} />
        </form>
      )}

      {tache.traitement2Form && (
        <div className={cardCls}>
          <ReadField label="Cycles traités" value={tache.traitement2Form.cycleTraite} />
          <ReadField label="Commentaire" value={tache.traitement2Form.commentaire1} />

          <p className="text-base font-bold text-[#5C1A30] text-center pt-2">Analyse par cycle</p>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>A - Régularité formelle</p>
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire2} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>B - Trésorerie / finances</p>
            <ReadField
              label="Rapprochement bancaire"
              value={tache.traitement2Form.rapprochementBanque}
            />
            <ReadField
              label="Souscription d'un nouvel emprunt ?"
              value={tache.traitement2Form.nouvelEmprunt}
            />
            <ReadField
              label="Variation significative de la trésorerie ?"
              value={tache.traitement2Form.variationSignificative}
            />
            <ReadField
              label="Evolution anormale du c/ct ?"
              value={tache.traitement2Form.evolutionAnormale}
            />
            <ReadField
              label="Frais de rejet ou agios dans les 6. ?"
              value={tache.traitement2Form.fraisRejet}
            />
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire3} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>C - Achats / fournisseurs</p>
            <ReadField
              label="Traitement du compte FDIVERS"
              value={tache.traitement2Form.fdivers}
            />
            <ReadField
              label="Lettrage des comptes fournisseurs"
              value={tache.traitement2Form.lettrage}
            />
            <ReadField
              label="Vérification et élimination des doublons"
              value={tache.traitement2Form.verificationElimination}
            />
            <ReadField
              label="Présence de dettes fournisseurs de plus de 6 mois"
              value={tache.traitement2Form.dettes}
            />
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire4} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>D - Charges externes</p>
            <ReadField label="Sondage du compte 60630" value={tache.traitement2Form.sondage} />
            <ReadField
              label="Evolution significative d'un compte de charges externes ?"
              value={tache.traitement2Form.evolutionSignificative}
            />
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire5} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>E - Ventes / clients</p>
            <ReadField label="Traitement du compte CDIVERS" value={tache.traitement2Form.cdivers} />
            <ReadField
              label="Lettrage des comptes clients"
              value={tache.traitement2Form.lettrageComtpes}
            />
            <ReadField
              label="Vérification et élimination des doublons"
              value={tache.traitement2Form.verificationElimination2}
            />
            <ReadField
              label="Présence de créances clients de plus de 6 mois"
              value={tache.traitement2Form.creanceClient}
            />
            <ReadField
              label="Evolution significative du chiffre d'affaires"
              value={tache.traitement2Form.evolutionChiffre}
            />
            <ReadField
              label="Impact de l'évolution du CA sur le régime de TVA"
              value={tache.traitement2Form.impactCA}
            />
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire6} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>F - Stocks et travaux-en-cours</p>
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire7} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>G - Immobilisations</p>
            <ReadField
              label="Création d'Immobilisations"
              value={tache.traitement2Form.immobilisation}
            />
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire8} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>H - Personnel</p>
            <ReadField label="Transfert des OD de paie" value={tache.traitement2Form.transfertOD} />
            <ReadField
              label="Retard de paiement des échéances antérieures"
              value={tache.traitement2Form.retardPaiement}
            />
            <ReadField
              label="Présence de dettes sociales élevées"
              value={tache.traitement2Form.presenceDettes}
            />
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire9} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>I - Etat</p>
            <ReadField
              label="Transfert des OD de TVA"
              value={tache.traitement2Form.tansfertODetTVA}
            />
            <ReadField
              label="Retard de paiement des échéances antérieures"
              value={tache.traitement2Form.retardPaiementEcheance}
            />
            <ReadField
              label="Présence de dettes fiscales élevées"
              value={tache.traitement2Form.dettesFiscales}
            />
            <ReadField
              label="Régime d'imposition à modifier"
              value={tache.traitement2Form.regimeImposition}
            />
            <ReadField
              label="L'ensemble des déclarations sont à jour"
              value={tache.traitement2Form.declarationAjour}
            />
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire10} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>J - Capitaux propres</p>
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire11} />
          </div>

          <div className={subCardCls}>
            <p className={cycleTitleCls}>K - Autres comptes</p>
            <ReadField label="Commentaire" value={tache.traitement2Form.commentaire12} />
          </div>
        </div>
      )}
    </>
  );
}

export default Traitement2Stage;
